import React from "react"
import PropTypes from "prop-types"
import { Modal, Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { CloseOutlined } from "@ant-design/icons"
import warningIcon from "assets/icons/warningIcon.svg"
import styles from "./UnsavedChangesModal.module.css"

const UnsavedChangesModal = ({ open, onDiscard, onKeepEditing, zIndex = 1100 }) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onCancel={onKeepEditing}
      closable={false}
      zIndex={zIndex}
      centered
      maskClosable={false}
      footer={null}
      width={400}
      className={styles.modal}
    >
      <Button type="text" onClick={onKeepEditing} className={styles.closeButton}>
        <CloseOutlined />
      </Button>

      <Flex justify="center" className="mb-m">
        <Flex justify="center" align="center" className={styles.warningIcon}>
          <img src={warningIcon} alt="warning" width="24" height="24" />
        </Flex>
      </Flex>

      <h2 className={styles.title}>{t("common.unsaved_changes_modal.title")}</h2>
      <p className={styles.description}>{t("common.unsaved_changes_modal.description")}</p>

      <Flex gap={8} className={styles.footer}>
        <Button color="primary" variant="outlined" onClick={onKeepEditing} className={styles.actionBtn}>
          {t("common.unsaved_changes_modal.keep_editing")}
        </Button>
        <Button type="primary" danger onClick={onDiscard} className={styles.actionBtn}>
          {t("common.unsaved_changes_modal.discard")}
        </Button>
      </Flex>
    </Modal>
  )
}

UnsavedChangesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onKeepEditing: PropTypes.func.isRequired,
  zIndex: PropTypes.number
}

export { UnsavedChangesModal }
